<form
  [formGroup]="searchForm"
  class="toolbar"
  *ngIf="isPdfLoaded"
>
  <mat-checkbox formControlName="wholeWords">Whole words</mat-checkbox>

  <div class="input-wrapper">
    <span class="material-icons">search</span>
    <input
      type="text"
      formControlName="query"
      placeholder="Search words in pdf"
    >
  </div>
</form>
<div class="pdf-iframe-container">
  <iframe
    class="pdf-iframe"
    *ngFor="let src of iframesSrc"
    [src]="src"
    (load)="onPdfLoad()"
    width="100%"
    height="720px"
  ></iframe>
</div>
